import { ascending } from 'vega-util';
function adjustSpatial(item, encode, swap) {
  var t;
  if (encode.x2) {
    if (encode.x) {
      if (swap && item.x > item.x2) {
        t = item.x;
        item.x = item.x2;
        item.x2 = t;
      }
      item.width = item.x2 - item.x;
    } else {
      item.x = item.x2 - (item.width || 0);
    }
  }
  if (encode.xc) {
    item.x = item.xc - (item.width || 0) / 2;
  }
  if (encode.y2) {
    if (encode.y) {
      if (swap && item.y > item.y2) {
        t = item.y;
        item.y = item.y2;
        item.y2 = t;
      }
      item.height = item.y2 - item.y;
    } else {
      item.y = item.y2 - (item.height || 0);
    }
  }
  if (encode.yc) {
    item.y = item.yc - (item.height || 0) / 2;
  }
}
var Constants = {
  NaN: NaN,
  E: Math.E,
  LN2: Math.LN2,
  LN10: Math.LN10,
  LOG2E: Math.LOG2E,
  LOG10E: Math.LOG10E,
  PI: Math.PI,
  SQRT1_2: Math.SQRT1_2,
  SQRT2: Math.SQRT2,
  MIN_VALUE: Number.MIN_VALUE,
  MAX_VALUE: Number.MAX_VALUE
};
var Ops = {
  '*': function _(a, b) {
    return a * b;
  },
  '+': function _(a, b) {
    return a + b;
  },
  '-': function _(a, b) {
    return a - b;
  },
  '/': function _(a, b) {
    return a / b;
  },
  '%': function _(a, b) {
    return a % b;
  },
  '>': function _(a, b) {
    return a > b;
  },
  '<': function _(a, b) {
    return a < b;
  },
  '<=': function _(a, b) {
    return a <= b;
  },
  '>=': function _(a, b) {
    return a >= b;
  },
  '==': function _(a, b) {
    return a == b;
  },
  '!=': function _(a, b) {
    return a != b;
  },
  '===': function _(a, b) {
    return a === b;
  },
  '!==': function _(a, b) {
    return a !== b;
  },
  '&': function _(a, b) {
    return a & b;
  },
  '|': function _(a, b) {
    return a | b;
  },
  '^': function _(a, b) {
    return a ^ b;
  },
  '<<': function _(a, b) {
    return a << b;
  },
  '>>': function _(a, b) {
    return a >> b;
  },
  '>>>': function _(a, b) {
    return a >>> b;
  }
};
var Unary = {
  '+': function _(a) {
    return +a;
  },
  '-': function _(a) {
    return -a;
  },
  '~': function _(a) {
    return ~a;
  },
  '!': function _(a) {
    return !a;
  }
};
var slice = Array.prototype.slice;
var apply = function apply(m, args, cast) {
  var obj = cast ? cast(args[0]) : args[0];
  return obj[m].apply(obj, slice.call(args, 1));
};
var datetime = function datetime(y, m, d, H, M, S, ms) {
  return new Date(y, m || 0, d != null ? d : 1, H || 0, M || 0, S || 0, ms || 0);
};
var Functions = {
  // math functions
  isNaN: Number.isNaN,
  isFinite: Number.isFinite,
  abs: Math.abs,
  acos: Math.acos,
  asin: Math.asin,
  atan: Math.atan,
  atan2: Math.atan2,
  ceil: Math.ceil,
  cos: Math.cos,
  exp: Math.exp,
  floor: Math.floor,
  log: Math.log,
  max: Math.max,
  min: Math.min,
  pow: Math.pow,
  random: Math.random,
  round: Math.round,
  sin: Math.sin,
  sqrt: Math.sqrt,
  tan: Math.tan,
  clamp: function clamp(a, b, c) {
    return Math.max(b, Math.min(c, a));
  },
  // date functions
  now: Date.now,
  utc: Date.UTC,
  datetime: datetime,
  date: function date(d) {
    return new Date(d).getDate();
  },
  day: function day(d) {
    return new Date(d).getDay();
  },
  year: function year(d) {
    return new Date(d).getFullYear();
  },
  month: function month(d) {
    return new Date(d).getMonth();
  },
  hours: function hours(d) {
    return new Date(d).getHours();
  },
  minutes: function minutes(d) {
    return new Date(d).getMinutes();
  },
  seconds: function seconds(d) {
    return new Date(d).getSeconds();
  },
  milliseconds: function milliseconds(d) {
    return new Date(d).getMilliseconds();
  },
  time: function time(d) {
    return new Date(d).getTime();
  },
  timezoneoffset: function timezoneoffset(d) {
    return new Date(d).getTimezoneOffset();
  },
  utcdate: function utcdate(d) {
    return new Date(d).getUTCDate();
  },
  utcday: function utcday(d) {
    return new Date(d).getUTCDay();
  },
  utcyear: function utcyear(d) {
    return new Date(d).getUTCFullYear();
  },
  utcmonth: function utcmonth(d) {
    return new Date(d).getUTCMonth();
  },
  utchours: function utchours(d) {
    return new Date(d).getUTCHours();
  },
  utcminutes: function utcminutes(d) {
    return new Date(d).getUTCMinutes();
  },
  utcseconds: function utcseconds(d) {
    return new Date(d).getUTCSeconds();
  },
  utcmilliseconds: function utcmilliseconds(d) {
    return new Date(d).getUTCMilliseconds();
  },
  // sequence functions
  length: function length(x) {
    return x.length;
  },
  join: function join() {
    return apply('join', arguments);
  },
  indexof: function indexof() {
    return apply('indexOf', arguments);
  },
  lastindexof: function lastindexof() {
    return apply('lastIndexOf', arguments);
  },
  slice: function slice() {
    return apply('slice', arguments);
  },
  reverse: function reverse(x) {
    return x.slice().reverse();
  },
  sort: function sort(x) {
    return x.slice().sort(ascending);
  },
  // string functions
  parseFloat: parseFloat,
  parseInt: parseInt,
  upper: function upper(x) {
    return String(x).toUpperCase();
  },
  lower: function lower(x) {
    return String(x).toLowerCase();
  },
  substring: function substring() {
    return apply('substring', arguments, String);
  },
  split: function split() {
    return apply('split', arguments, String);
  },
  replace: function replace() {
    return apply('replace', arguments, String);
  },
  trim: function trim(x) {
    return String(x).trim();
  },
  // Base64 encode/decode
  // Convert binary string to base64-encoded ascii
  btoa: function (_btoa) {
    function btoa(_x) {
      return _btoa.apply(this, arguments);
    }
    btoa.toString = function () {
      return _btoa.toString();
    };
    return btoa;
  }(function (x) {
    return btoa(x);
  }),
  // Convert base64-encoded ascii to binary string
  atob: function (_atob) {
    function atob(_x2) {
      return _atob.apply(this, arguments);
    }
    atob.toString = function () {
      return _atob.toString();
    };
    return atob;
  }(function (x) {
    return atob(x);
  }),
  // regexp functions
  regexp: RegExp,
  test: function test(r, t) {
    return RegExp(r).test(t);
  }
};
var EventFunctions = ['view', 'item', 'group', 'xy', 'x', 'y'];
var DisallowedMethods = new Set([Function, eval, setTimeout, setInterval]);
if (typeof setImmediate === 'function') DisallowedMethods.add(setImmediate);
var Visitors = {
  Literal: function Literal($, n) {
    return n.value;
  },
  Identifier: function Identifier($, n) {
    var id = n.name;
    return $.memberDepth > 0 ? id : id === 'datum' ? $.datum : id === 'event' ? $.event : id === 'item' ? $.item : Constants[id] || $.params['$' + id];
  },
  MemberExpression: function MemberExpression($, n) {
    var d = !n.computed,
      o = $(n.object);
    if (d) $.memberDepth += 1;
    var p = $(n.property);
    if (d) $.memberDepth -= 1;
    if (DisallowedMethods.has(o[p])) {
      // eslint-disable-next-line no-console
      console.error("Prevented interpretation of member \"".concat(p, "\" which could lead to insecure code execution"));
      return;
    }
    return o[p];
  },
  CallExpression: function CallExpression($, n) {
    var args = n.arguments;
    var name = n.callee.name;

    // handle special internal functions used by encoders
    // re-route to corresponding standard function
    if (name.startsWith('_')) {
      name = name.slice(1);
    }

    // special case "if" due to conditional evaluation of branches
    return name === 'if' ? $(args[0]) ? $(args[1]) : $(args[2]) : ($.fn[name] || Functions[name]).apply($.fn, args.map($));
  },
  ArrayExpression: function ArrayExpression($, n) {
    return n.elements.map($);
  },
  BinaryExpression: function BinaryExpression($, n) {
    return Ops[n.operator]($(n.left), $(n.right));
  },
  UnaryExpression: function UnaryExpression($, n) {
    return Unary[n.operator]($(n.argument));
  },
  ConditionalExpression: function ConditionalExpression($, n) {
    return $(n.test) ? $(n.consequent) : $(n.alternate);
  },
  LogicalExpression: function LogicalExpression($, n) {
    return n.operator === '&&' ? $(n.left) && $(n.right) : $(n.left) || $(n.right);
  },
  ObjectExpression: function ObjectExpression($, n) {
    return n.properties.reduce(function (o, p) {
      $.memberDepth += 1;
      var k = $(p.key);
      $.memberDepth -= 1;
      if (DisallowedMethods.has($(p.value))) {
        // eslint-disable-next-line no-console
        console.error("Prevented interpretation of property \"".concat(k, "\" which could lead to insecure code execution"));
      } else {
        o[k] = $(p.value);
      }
      return o;
    }, {});
  }
};
function interpret(ast, fn, params, datum, event, item) {
  var _$ = function $(n) {
    return Visitors[n.type](_$, n);
  };
  _$.memberDepth = 0;
  _$.fn = Object.create(fn);
  _$.params = params;
  _$.datum = datum;
  _$.event = event;
  _$.item = item;

  // route event functions to annotated vega event context
  EventFunctions.forEach(function (f) {
    return _$.fn[f] = function () {
      var _event$vega;
      return (_event$vega = event.vega)[f].apply(_event$vega, arguments);
    };
  });
  return _$(ast);
}
var expression = {
  /**
   * Parse an expression used to update an operator value.
   */
  operator: function operator(ctx, expr) {
    var ast = expr.ast,
      fn = ctx.functions;
    return function (_) {
      return interpret(ast, fn, _);
    };
  },
  /**
   * Parse an expression provided as an operator parameter value.
   */
  parameter: function parameter(ctx, expr) {
    var ast = expr.ast,
      fn = ctx.functions;
    return function (datum, _) {
      return interpret(ast, fn, _, datum);
    };
  },
  /**
   * Parse an expression applied to an event stream.
   */
  event: function event(ctx, expr) {
    var ast = expr.ast,
      fn = ctx.functions;
    return function (event) {
      return interpret(ast, fn, undefined, undefined, event);
    };
  },
  /**
   * Parse an expression used to handle an event-driven operator update.
   */
  handler: function handler(ctx, expr) {
    var ast = expr.ast,
      fn = ctx.functions;
    return function (_, event) {
      var datum = event.item && event.item.datum;
      return interpret(ast, fn, _, datum, event);
    };
  },
  /**
   * Parse an expression that performs visual encoding.
   */
  encode: function encode(ctx, _encode) {
    var marktype = _encode.marktype,
      channels = _encode.channels,
      fn = ctx.functions,
      swap = marktype === 'group' || marktype === 'image' || marktype === 'rect';
    return function (item, _) {
      var datum = item.datum;
      var m = 0,
        v;
      for (var name in channels) {
        v = interpret(channels[name].ast, fn, _, datum, undefined, item);
        if (item[name] !== v) {
          item[name] = v;
          m = 1;
        }
      }
      if (marktype !== 'rule') {
        adjustSpatial(item, channels, swap);
      }
      return m;
    };
  }
};
export { expression as expressionInterpreter };